import React from "react";
import { LayoutDashboard, Building2, Users, CreditCard } from "lucide-react";
import { SidebarLayout } from "@/components/SidebarLayout";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/", label: "Tableau de bord", icon: LayoutDashboard, testid: "admin-nav-dashboard", end: true },
  { to: "/societes", label: "Sociétés", icon: Building2, testid: "admin-nav-companies" },
  { to: "/utilisateurs", label: "Utilisateurs", icon: Users, testid: "admin-nav-users" },
  { to: "/paiements", label: "Paiements", icon: CreditCard, testid: "admin-nav-payments" },
];

export function AdminLayout({ children }) {
  const { user } = useAuth();
  return (
    <SidebarLayout nav={NAV} title="Administration PACEMIA" subtitle={user?.email}>
      {children}
    </SidebarLayout>
  );
}
